import Container from 'react-bootstrap/Container';

export default function Footer({ version }) {
  const year = new Date().getFullYear();
  return (
    <footer
      className="bg-white border-top mt-auto"
      style={{ fontSize: '0.85rem' }}
    >
      <Container fluid="lg" className="py-4">
        <div className="d-flex flex-wrap justify-content-between align-items-center gap-3">
          <div className="text-muted">
            &copy; {year} Podium Education. All rights reserved.
          </div>
          <nav>
            <ul className="list-inline mb-0">
              <li className="list-inline-item me-3">
                <a
                  href="https://podiumeducation.com/privacy"
                  target="_blank"
                  rel="noreferrer"
                  className="text-decoration-none text-secondary"
                >
                  Privacy
                </a>
              </li>
              <li className="list-inline-item me-3">
                <a
                  href="https://podiumeducation.com/terms"
                  target="_blank"
                  rel="noreferrer"
                  className="text-decoration-none text-secondary"
                >
                  Terms
                </a>
              </li>
              {version && (
                <li className="list-inline-item text-muted">
                  Howdy v{version}
                </li>
              )}
            </ul>
          </nav>
        </div>
      </Container>
    </footer>
  );
}
